import Vue from 'vue'
import Vuex from 'vuex'
import auth from '@/store/modules/auth'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		user: {
			email: null,
			name: null,
			image: null,
			google_id_token: null,
			maestroAuth: null,
			maestroUserId: null
		},
		uiMemories: {
			explorer: {
				file_filter: '',
				folder_path: '',
				selected_link: '',
				ref_suifa: '',
				ref_suifa_asset_info: [],
				selected_files: []
			},
			pkg_lag: {
				status_selected: 'PENDING',
				prid_selected: '',
				title_selected: '',
				dir_selected: 'C:/TEMP/__LAG/ASSETS'
			},
			configs: {
				filter: ''
			},
			vantage: {
				filter: ''
			},
			jobs: {
				filter: ''
			}
		},
		fileOpenerFallback: {
			visible: false,
			message: null,
			status: null
		},
		cplParser: {
			visible: false,
			cplName: null,
			data: null
		},
		nexus_api_status: null,
		maestro_api_status: null,
		maestro_es_status: null,
		fileopener_status: null,
		apps_status: {
			BeHive: {
				status: 0,
				message: ''
			},
			Maestro: {
				status: 0,
				message: ''
			},
			Gravity: {
				status: 0,
				message: ''
			},
			T1000: {
				status: 0,
				message: ''
			},
			ACME: {
				status: 0,
				message: ''
			}
		}
	},
	getters: {
		ui_memories: state => {
			return state.uiMemories
		},
		user: state => {
			return state.user
		},
		fileOpenerFallback: state => {
			return state.fileOpenerFallback
		},
		cplParser: state => {
			return state.cplParser
		},
		nexus_api_status: state => {
			return state.nexus_api_status
		},
		maestro_api_status: state => {
			return state.maestro_api_status
		},
		maestro_es_status: state => {
			return state.maestro_es_status
		},
		fileopener_status: state => {
			return state.fileopener_status
		},
		apps_status: state => {
			return state.apps_status
		}
	},
	mutations: {
		set_ui_memory (state, data) {
			state.uiMemories[data.app] = data.memories
		},
		set_user (state, data) {
			state.user = data
			window.localStorage.setItem('jd_list_light', false)
		},
		fileOpenerFallbackChange (state, payload) {
			state.fileOpenerFallback = payload
		},
		setCplParser (state, payload) {
			state.cplParser = payload
		},
		set_nexus_api_status (state, payload) {
			state.nexus_api_status = payload
		},
		set_maestro_api_status (state, payload) {
			state.maestro_api_status = payload
		},
		set_maestro_es_status (state, payload) {
			state.maestro_es_status = payload
		},
		set_fileopener_status (state, payload) {
			state.fileopener_status = payload
		},
		set_apps_status (state, payload) {
			state.apps_status = payload
		}
	},
	modules: {
		auth
	}
})



// WEBPACK FOOTER //
// ./src/store/store.js